<template>
  <!-- Search component -->
  <search-comp @onSearch="onSearch" @onReset="onReset">
    <template>
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row align-end">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Khách</div>
                <div class="child-w-80">
                  <input v-model="searchParams.customer_info" type="text" />
                </div>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Cty, đại lý du lịch</div>
                <div class="child-w-80">
                  <input v-model="searchParams.company_info" type="text" />
                </div>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Ngày đến</div>
                <div class="child-w-80">
                  <CalendarRange
                    v-model="arrivePeriod"
                    style="display: block"
                    mode="date"
                  />
                  <!-- <MultiCalendar
                    class="use-icon"
                    :from-date="searchParams.arrive_from"
                    :to-date="searchParams.arrive_to"
                  /> -->
                </div>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Ngày đi</div>
                <CalendarRange
                  v-model="departPeriod"
                  style="display: block"
                  mode="date"
                />
                <!-- <div class="child-w-80"> -->
                <!-- <MultiCalendar
                    class="use-icon"
                    :from-date="searchParams.depart_from"
                    :to-date="searchParams.depart_to"
                  /> -->
                <!-- </div> -->
              </div>
            </div>
          </div>
          <div class="das-form-row align-end">
            <div class="das-form-col col-9">
              <div class="checkbox-container">
                <div class="checkbox-wrap">
                  <input
                    id="cpSpdTp1"
                    v-model="searchParams.surplus"
                    type="checkbox"
                  />
                  <label for="cpSpdTp1">Số dư khác 0</label>
                </div>
                <div class="checkbox-wrap">
                  <input
                    id="cpSpdTp2"
                    v-model="searchParams.check_out_today"
                    type="checkbox"
                  />
                  <label for="cpSpdTp2">C/O trong ngày</label>
                </div>
                <div class="das-form-input" style="display: flex; gap: 20px">
                  <div class="checkbox-wrap">
                    <input
                      id="cpSpdTp3"
                      v-model="searchParams.reserved"
                      type="checkbox"
                    />
                    <label for="cpSpdTp3">Đã đặt</label>
                  </div>
                  <div class="checkbox-wrap">
                    <input
                      id="cpSpdTp4"
                      v-model="searchParams.in_house"
                      type="checkbox"
                    />
                    <label for="cpSpdTp4">Đang ở</label>
                  </div>
                  <div class="checkbox-wrap">
                    <input
                      id="cpSpdTp5"
                      v-model="searchParams.checked_out"
                      type="checkbox"
                    />
                    <label for="cpSpdTp5">Đã trả phòng</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Mã đặt phòng</div>
                <div class="child-w-80">
                  <input v-model="searchParams.recode" type="text" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </search-comp>
</template>
<script>
/* eslint-disable */
export default {
  props: {
    recode: {
      type: String
    },
    status: {
      default: null
    }
  },
  data() {
    return {
      arrivePeriod: {},
      departPeriod: {},
      searchParams: {
        customer_info: null,
        company_info: null,
        arrive_from: null,
        arrive_to: null,
        depart_from: null,
        depart_to: null,
        surplus: null,
        check_out_today: null,
        reserved: null,
        in_house: true,
        checked_out: null,
        recode: null
      }
    }
  },
  watch: {
    arrivePeriod(data) {
      this.searchParams.arrive_from = data.start || null
      this.searchParams.arrive_to = data.end || null
    },
    departPeriod(data) {
      this.searchParams.depart_from = data.start || null
      this.searchParams.depart_to = data.end || null
    }
  },
  mounted() {
    if (this.recode) {
      console.log('hahah')
      this.$nullValueInObj(this.searchParams)

      this.searchParams.recode = this.recode

      if (this.status == 1) {
        this.searchParams.reserved = true
      } else if (this.status == 2) {
        this.searchParams.in_house = true
      } else {
        this.searchParams.checked_out = true
      }
    }
    setTimeout(() => {
      this.onSearch()
    }, 500)
  },
  methods: {
    onSearch() {
      this.$emit('onSearch', this.searchParams)
    },
    onReset() {
      this.$nullValueInObj(this.searchParams)
      this.searchParams.in_house = true
      this.$emit('onReset', this.searchParams)
      this.arrivePeriod = {}
      this.departPeriod = {}
    }
  }
}
</script>
